import AssetLoader from "../loader/AssetLoader.js";
import "../loader/ImageLoader.js";
import "../global-33d5eebf.js";
import "pixi.js";
import "../loader/SpriteLoader.js";
import "../loader/PixiSpriteLoader.js";
import "../loader/MapLoader.js";
import "./colors.js";
import "./sharedFetch.js";
import "../vendor/noise/index.js";
import "url";
import "@dimforge/rapier2d-compat";
import "../persist/persist.js";
import "../loader/PixiSpineLoader.js";
import "pixi-spine";
import "../loader/SoundLoader.js";
import "../_commonjsHelpers-7a77ea84.js";
const playSound = (name, { volume = 1 } = {}) => {
  const [sound, soundOptions] = AssetLoader.getInstance().getSound(name);
  sound.volume = (soundOptions.baseVolume ?? 1) * volume;
  sound.play();
};
export {
  playSound
};
//# sourceMappingURL=playSound.js.map
